<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.timeZones')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.timeZones')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>Geçiş Parametreleri Listesi</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div
                v-show="timeZoneList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <tbody>
                    <tr v-for="timeZone in timeZoneList" :key="timeZone.id">
                      <td>
                        <span>{{timeZone.name}}</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="getTZDetail(timeZone.id)">
                          <i class="fa fa-search"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="timeZoneList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> Geçiş parametreleri bulunamadı.
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>Geçiş Parametre Detayı</span>
              </h3>
              <div class="box-tools pull-right"></div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Parametre Kodu</label>
                    <input
                      type="number"
                      max="50"
                      class="form-control text-center"
                      v-model="timeZone.code"
                    />
                  </div>
                </div>
                <div class="col-sm-9">
                  <div class="form-group">
                    <label>Parametre Adı</label>
                    <input type="text" class="form-control" v-model="timeZone.name" />
                  </div>
                </div>
              </div>
              <hr />
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.monday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.tuesday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.wednesday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.thursday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.friday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.saturday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
              <div class="row" align="center" style="margin-top:10px;">
                <div class="col-sm-3">{{$ml.get('general.sunday')}} :</div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
                <div class="col-sm-3">
                  <input type="time" class="form-control" />
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-footer">
              <div class="pull-right">
                <button
                  v-show="!isNewTimeZone"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-sil"
                  class="btn btn-sm btn-danger "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.delete")}}</button>
                <button
                  v-show="isNewTimeZone"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-kaydet"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.save")}}</button>
                <button
                  v-show="!isNewTimeZone"
                  type="button"
                  data-toggle="modal"
                  data-target="#modal-guncelle"
                  class="btn btn-sm btn-success "
                  style="margin: 5px; width:120px;"
                >{{$ml.get("general.update")}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isNewTimeZone: true,
      timeZones: [],
      timeZone: {
        id: null,
        code: 1,
        name: ""
      }
    };
  },
  computed: {
    timeZoneList() {
      return this.timeZones;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    getTZDetail(id) {}
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/timeZones/TimeZone.vue